import { customizationData } from './customization.data';

export const customizationService = {
  getCustomizationElements: (customerId: number) => customizationData.getCustomizationElements(customerId),
};
